import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { ChatContext } from "../context/ChatContext";

const Message = ({ message }) => {
  const { currentUser } = useContext(AuthContext);
  const { data } = useContext(ChatContext);

  const ref = useRef();

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  const getSenderInfo = () => {
    if (message.senderId === currentUser.uid) {
      return {
        photoURL: currentUser.photoURL,
        displayName: "You"
      };
    }
    
    if (data.isGroupChat && data.groupInfo?.members) {
      const sender = data.groupInfo.members.find(m => m.uid === message.senderId);
      return {
        photoURL: sender?.photoURL || "https://via.placeholder.com/40",
        displayName: sender?.displayName || "Unknown"
      };
    }
    
    return {
      photoURL: data.user.photoURL,
      displayName: data.user.displayName
    };
  };

  const senderInfo = getSenderInfo();

  return (
    <div
      ref={ref}
      className={`message ${message.senderId === currentUser.uid && "owner"}`}
    >
      <div className="messageInfo">
        <img src={senderInfo.photoURL} alt="" />
        <span>just now</span>
      </div>
      <div className="messageContent">
        {data.isGroupChat && message.senderId !== currentUser.uid && (
          <div className="senderName">{senderInfo.displayName}</div>
        )}
        <p>{message.text}</p>
        {message.img && <img src={message.img} alt="" />}
      </div>
    </div>
  );
};

export default Message;
